import * as _ from 'lodash'
import React from 'react';
import jobCostNoteFactory from '../models/jobCostNoteModel';
import componentServices from '../componentServices';
import * as contractorActions from '../contractorActions';
import util from '../util';
import globalRelay from '../globalRelay';
import valueFilters from '../valueFilters';
import jobFactory from '../models/jobModel';
import { Radio } from './sharedComponents';
import { getModel, ModelCollection } from 'Scripts/store';

export default class JobCostEditSubmitChangeOrder extends React.Component<any,any> {
	private _afterNoteSaved;

	constructor (props) {
		super(props);

		this.state = this.getStateFromProps(props);
		this._afterNoteSaved = null;

		this.buttonAction = this.buttonAction.bind(this);
		this.handleNoteChange = this.handleNoteChange.bind(this);
		this.handleTransactionMethodChange = this.handleTransactionMethodChange.bind(this);
		this.handleTransactionReferenceChange = this.handleTransactionReferenceChange.bind(this);
		this.onCustomerApprovedChange = this.onCustomerApprovedChange.bind(this);
	}

	UNSAFE_componentWillReceiveProps (newProps) {
		this.setState(this.getStateFromProps(newProps));
	}

	getStateFromProps (props) {
		const { store } = componentServices;
		const { jobCost } = props;
		const state = _.assign({ transactionMethod: '', transactionReference: '' }, this.state);
		const job = getModel({ store, collection: ModelCollection.jobs, key: jobCost.jobKey });
		const builder = job.builderKey ? getModel({ store, collection: ModelCollection.contractors, key: job.builderKey }) : undefined;

		if ((!job.builderKey || builder) && (state.jobCostKey !== jobCost.key || state.jobCostItemVersion !== jobCost.itemVersion)) {
			if (state.jobCostKey !== jobCost.key) {
				state.customerApproved = (['locked', 'rejected'].indexOf(jobCost.currentChangeOrder.currentStatus) !== -1) ? undefined : '1';

				const payments = job.getSystemGeneratedPayments(jobCost.currentChangeOrder.key);
				if (payments.length) {
					state.transactionMethod = payments[0].transactionMethod;
					state.transactionReference = payments[0].transactionReference;
				}
			}

			// only the first payment is due at submission
			const orderedPayments = _.orderBy(jobCost.paymentTerms, ['sortIndex']);
			state.amountDue = orderedPayments.length ? orderedPayments[0].amountDue : 0;
			state.changeOrder = jobCost.currentChangeOrder;
			state.job = job;
			state.builder = builder;
			state.jobCostKey = jobCost.key;
			state.jobCostItemVersion = jobCost.itemVersion;
		}

		if (!builder && job.builderKey) {
			contractorActions.fetchContractor({ key: job.builderKey });
		}

		return state;
	}

	handleNoteChange (e) {
		const options = e.type === 'blur' ? { autoSave: true } : { autoSave: false };
		const newVal = e.type === 'blur' ? valueFilters.clean(e.target.value) : e.target.value;

		(options as any).callback = (err) => {
			if (!err && this._afterNoteSaved) {
				this._afterNoteSaved();
				this._afterNoteSaved = null;
			}
		};

		this.props.updateModel(jobCost => {
			const note = _.find(jobCost.notes, { type: jobCostNoteFactory.NOTE_TYPES.CONTRACT_FOR_OPERATIONS }) || jobCostNoteFactory({ type: jobCostNoteFactory.NOTE_TYPES.CONTRACT_FOR_OPERATIONS });

			note.content = newVal;
			jobCost.notes.set(note.key, note);
		}, options);
	}

	handleTransactionMethodChange (e) {
		const newVal = e.target.value;

		this.setState(previousState => {
			const newState = _.assign({}, previousState);

			newState.transactionMethod = newVal;

			return newState;
		});
	}

	handleTransactionReferenceChange (e) {
		const newVal = e.type === 'blur' ? valueFilters.clean(e.target.value) : e.target.value;

		this.setState(previousState => {
			const newState = _.assign({}, previousState);

			newState.transactionReference = newVal;

			return newState;
		});
	}

	hasOperationsNote () {
		const { jobCost } = this.props;

		return !!jobCost.getNoteContent(jobCostNoteFactory.NOTE_TYPES.CONTRACT_FOR_OPERATIONS);
	}

	canSubmit () {
		const { summary } = this.props;
		const { amountDue, builder, customerApproved, transactionMethod, transactionReference } = this.state;
		const contractTotal = summary.grandTotalContract;
		const builderPasses = !contractTotal || !builder || ['account', 'purchase-order'].indexOf(transactionMethod) === -1 || builder.currentStatus !== 'locked';
		const hasTransactionInfo = !amountDue || (transactionMethod && (['account', 'cash'].indexOf(transactionMethod) !== -1 || transactionReference));

		return customerApproved === '1' && builderPasses && hasTransactionInfo && this.hasOperationsNote();
	}

	onCustomerApprovedChange (newButton) {
		if (['locked', 'rejected'].indexOf(this.state.changeOrder.currentStatus) === -1) {
			return;
		}

		// set state to force a re-render
		this.setState(previousState => {
			const newState = _.assign({}, previousState);

			newState.customerApproved = newButton.value;

			return newState;
		});
	}

	buttonAction () {
		const saveState = componentServices.store.getIn(['viewState', 'globalSave', 'state']);

		if (!this.canSubmit()) { return; }

		if (saveState !== 0) {
			this._afterNoteSaved = () => {
				this.buttonAction();
			};
			return;
		}

		const { amountDue, job, transactionMethod, transactionReference } = this.state;
		const options = { autoSave: true };

		this.props.updateModel(jobCost => {
			const changeOrder = jobCost.currentChangeOrder;

			changeOrder.statusLog.add({ status: 'pending-approval' });

			const jobUpdate = jobFactory(job.toDocument());
			const payments = jobUpdate.getSystemGeneratedPayments(changeOrder.key);
			if (payments.length) {
				const payment = payments[0];
				payment.transactionMethod = transactionMethod;
				payment.transactionReference = transactionReference;
				payment.amount = amountDue;
			}
			else if (amountDue) {
				jobUpdate.payments.add({ changeOrderKey: changeOrder.key, type: 'other', transactionMethod: transactionMethod, transactionReference: transactionReference, amount: amountDue, systemGenerated: true });
			}

			const jobPatch = jobUpdate.getPatch(job);

			if (jobPatch.length) {
				(options as any).extraneousPatch = [{
					op: 'replace',
					path: '../job',
					value: jobPatch
				}];
			}
		}, options);
	}

	render () {
		const { jobCost, summary } = this.props;
		const { amountDue, changeOrder, customerApproved, transactionMethod, transactionReference } = this.state;
		const operationsNote = jobCost.getNoteContent(jobCostNoteFactory.NOTE_TYPES.CONTRACT_FOR_OPERATIONS);
		const customerApprovedButtons = [
			{ classNames: ['icon yes'], isSelected: (customerApproved === '1'), value: '1' },
			{ classNames: ['icon no'], isSelected: (customerApproved === '0'), value: '0' }
		];

		const customerApprovedRadio = (<Radio buttons={ customerApprovedButtons } onChange={ this.onCustomerApprovedChange } />);

		const submitButtonClasses = ['action', 'iconLabel', 'submitToOrderDesk'];

		if (changeOrder.currentStatus !== 'locked') {
			submitButtonClasses.push('locked');
		}
		if (!this.canSubmit()) {
			submitButtonClasses.push('disabled');
		}

		const submitted = ['locked', 'rejected'].indexOf(changeOrder.currentStatus) === -1;
		const submitButtonText = submitted ? 'IN REVIEW BY ORDER DESK' : 'SUBMIT TO ORDER DESK';
		const submitButton = ['locked', 'rejected', 'pending-approval'].indexOf(changeOrder.currentStatus) !== -1 ? (<button className={ submitButtonClasses.join(' ') } onClick={ this.buttonAction }><span>{ submitButtonText }</span></button>) : null;

		const mainHeader = amountDue ? (<header><span>PAYMENT INFORMATION</span></header>) : <header><span>SUBMIT</span></header>;
		const subHeader = amountDue ? (<header><span>SUBMIT</span></header>) : null;
		const paymentSection = amountDue ? (<div className='inner compact'>
			<table cellPadding="0" cellSpacing="0">
				<tbody>
					<tr className={ (submitted ? 'disabled' : '') }>
						<td />
						<td><strong>Total Amount</strong></td>
						<td>{ util.formatAsCurrency(summary.grandTotalContract) }</td>
						<td />
					</tr>
					<tr className={ (submitted ? 'disabled' : '') }>
						<td />
						<td><strong>Amount Due</strong></td>
						<td>{ util.formatAsCurrency(amountDue) }</td>
						<td />
					</tr>
					<tr className={ (submitted ? 'disabled' : '') }>
						<td />
						<td><strong>Payment Method</strong></td>
						<td>
							<select value={ util.reactVal(transactionMethod) } onChange={ this.handleTransactionMethodChange }>
								<option value="">Select</option>
								<option value="cheque">{ globalRelay.config!.getString('Cheque') }</option>
								<option value="credit-card">Credit Card</option>
								{ changeOrder.transactionAccount === 'Builder' ? <option value="purchase-order">Purchase Order</option> : null }
								<option value="cash">Cash</option>
								{ changeOrder.transactionAccount === 'Builder' ? <option value="account">Account</option> : null }
							</select>
						</td>
						<td />
					</tr>
					<tr className={ (submitted ? 'disabled' : '') }>
						<td />
						<td><strong>Transaction Reference</strong></td>
						<td><input type="text" autoCapitalize="" autoCorrect="off" placeholder="" value={ transactionReference } onChange={ this.handleTransactionReferenceChange } onBlur={ this.handleTransactionReferenceChange } /></td>
						<td />
					</tr>
				</tbody>
			</table>

		</div>) : null;

		return (
			<section className="jobCostFinalize">
				{ mainHeader }
				{ paymentSection }
				{ /* Final Details */ }
				<section>
					{ subHeader }
					<div className="inner compact">
						<table cellPadding="0" cellSpacing="0">
							<tbody>
								<tr className={ customerApproved === '1' ? 'yes' : customerApproved === '0' ? 'no' : '' }>
									<td />
									<td><strong>Customer Approved?</strong></td>
									<td>
										{ customerApprovedRadio }
									</td>
									<td />
								</tr>
								<tr className={ (submitted ? 'disabled' : this.hasOperationsNote() ? '' : 'required') }>
									<td />
									<td><strong>Notes for Operations</strong></td>
									<td><textarea value={ operationsNote } onChange={ this.handleNoteChange } onBlur={ this.handleNoteChange } /></td>
									<td />
								</tr>
								<tr className={ (submitted ? 'disabled' : '') }>
									<td />
									<td />
									<td> { submitButton }</td>
									<td />
								</tr>
							</tbody>
						</table>

					</div>
				</section>

			</section>
		);
	}
}
